export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7e29f78a02189bfac78816fbfc253a8f37c2b688&name=fetchTypeahead!'